import type {RouteRecordRaw} from "vue-router";

export const routeName = 'IncomingDocument';

export const route: RouteRecordRaw = {
    name: routeName,
    path: ':id(\\d+)',
    component: () => import('@/pages/Document'),
    props: route => ({
        documentId: Number(route.params.id),
        context: 'incoming'
    }),
    meta: {
        isHide: true,
        title: 'incoming'
    }
};